// RoomBadge — the doctor-level room banner shown when a doctor is assigned a
// single room. Mirrors v1's CompactRoomDisplay 1:1 (blue gradient pill, room
// icon, "Room" label + name) so the v2 board matches the v1 look.
import React from "react";

const RoomBadge: React.FC<{ roomName: string; large?: boolean }> = ({
  roomName,
  large,
}) => {
  if (!roomName) return null;

  return (
    <div className="bg-gradient-to-r from-blue-500 to-blue-800 rounded-full px-4 py-1 shadow-md border border-blue-600/20">
      <div className="flex items-center justify-center">
        <div
          className={`bg-white/20 rounded-full mr-2 flex items-center justify-center ${
            large ? "w-10 h-10" : "w-8 h-8"
          }`}
        >
          <svg
            className={`text-white ${large ? "w-5 h-5" : "w-4 h-4"}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            />
          </svg>
        </div>
        <div className="text-center">
          <p
            className={`text-white font-medium opacity-80 ${
              large ? "text-xs" : "text-[0.625rem]"
            }`}
          >
            Room
          </p>
          <p
            className={`text-white font-semibold truncate ${
              large ? "text-lg" : "text-sm"
            }`}
          >
            {roomName}
          </p>
        </div>
      </div>
    </div>
  );
};

export default RoomBadge;
